<template>
    <div class="expiration-info" v-if="reservationTimedOut">
        <div class="box">
            <h2 class="h1 text-danger text-center">Čas na rezerváciu vypršal!</h2>

            <p class="m-b-sm">Môžete rezerváciu uskutočniť znova výberom termínu.</p>

            <div class="btn-wrap">
                <a :href="link" class="btn-secondary center">Vybrať termín</a>
            </div>
        </div>
    </div>
</template>

<script lang="ts" setup>

import { computed } from 'vue';
import { useTripInfo } from '../modules/useTripInfo';
import { useReservationTime } from '../modules/useReservationTime';

const tripInfo = useTripInfo();
const { reservationTimedOut } = useReservationTime();

const link = computed(() => `${tripInfo.url}#trip_dates`);
</script>
